import { render } from "./ClientSpaceBecomeSeller.vue?vue&type=template&id=6866733f&scoped=true"
import script from "./ClientSpaceBecomeSeller.vue?vue&type=script&lang=js"
export * from "./ClientSpaceBecomeSeller.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=6866733f&lang=scss&scoped=true"
import "./custom-become-seller.scss?vue&type=style&index=1&id=6866733f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6866733f"]])

export default __exports__